import axios, { AxiosResponse } from 'axios';
import Cookies from 'universal-cookie';

import { EventsListApiResponse, EventsListParams } from 'routes/events/types/events.types';

import { CookiesKeys } from '../enums/cookies-keys.enum';

import {
  validateEventStatusNumbers,
  validateHighlighted,
  validateOrdering,
  validatePage,
  validatePageSize,
  validateRewardTypeStrings,
  validateSearch,
} from 'routes/events/utils/validation';

export const getEventsListService = (
  params: EventsListParams,
  signal: AbortSignal
): Promise<AxiosResponse<EventsListApiResponse>> => {
  const queryParams: Record<string, string | number | boolean | (string | number)[]> = {};

  const validatedSearch = validateSearch(params.search);
  if (validatedSearch) {
    queryParams.search = validatedSearch;
  }

  const validatedOrdering = validateOrdering(params.ordering);
  if (validatedOrdering) {
    queryParams.ordering = validatedOrdering;
  }

  if (params.visible !== undefined) {
    queryParams.visible = Boolean(params.visible);
  }

  const validatedHighlighted = validateHighlighted(params.highlighted);
  if (validatedHighlighted !== null) {
    queryParams.highlighted = validatedHighlighted;
  }

  if (params.status !== undefined) {
    const statusArray = Array.isArray(params.status) ? params.status : [params.status];
    const validStatuses = validateEventStatusNumbers(statusArray);
    if (validStatuses.length > 0) {
      queryParams.status = validStatuses;
    }
  }

  if (params.reward_type !== undefined) {
    const rewardTypeArray = Array.isArray(params.reward_type) ? params.reward_type : [params.reward_type];
    const validRewardTypes = validateRewardTypeStrings(rewardTypeArray);
    if (validRewardTypes.length > 0) {
      queryParams.reward_type = validRewardTypes;
    }
  }
  if (params.list_mode && params.list_mode.length > 0) {
    queryParams.list_mode = params.list_mode.join(',');
  }
  if (params.event_type && params.event_type.length > 0) {
    queryParams.event_type = params.event_type.join(',');
  }
  if (params.event_label !== undefined) {
    queryParams.event_label = params.event_label || '';
  }
  if (params.start_after) queryParams.start_after = params.start_after;
  if (params.start_before) queryParams.start_before = params.start_before;
  if (params.end_after) queryParams.end_after = params.end_after;
  if (params.end_before) queryParams.end_before = params.end_before;
  const validatedPage = validatePage(params.page);
  if (validatedPage !== null) {
    queryParams.page = validatedPage;
  }
  const validatedPageSize = validatePageSize(params.page_size);
  if (validatedPageSize !== null) {
    queryParams.page_size = validatedPageSize;
  }

  const axiosParams = new URLSearchParams();
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          axiosParams.append(key, String(item));
        });
      } else {
        axiosParams.append(key, String(value));
      }
    }
  });

  return axios.get('/api/v1/events/', {
    signal,
    params: axiosParams,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};
